import { render } from "./FileIcon.vue?vue&type=template&id=f6419ba4"
import script from "./FileIcon.vue?vue&type=script&lang=js"
export * from "./FileIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Files/FileIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6419ba4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6419ba4', __exports__)) {
    console.log('reload')
    api.reload('f6419ba4', __exports__)
  }
  
  module.hot.accept("./FileIcon.vue?vue&type=template&id=f6419ba4", () => {
    console.log('re-render')
    api.rerender('f6419ba4', render)
  })

}


export default __exports__